






import {Component} from "vue-property-decorator"
import AbpBase from "../../../lib/abpbase"

@Component
export default class Blood extends AbpBase{
	year = new Date()
	loading = false
	columns = [
		{title:'姓名'},
		{title:'通路类型'},
		{title:'血流量(ml/min)'},
		{title:'干体重(kg)'},
		{title:"血流量/干体重"},
		{title:"透析液流量(ml/min)"},
		{title:"透析器型号"},
		{title:"透析总时间(小时:分钟)"},
		{title:"透析次数"},
		{title:"spKt/V"},
		{title:"eKt/V"},
		{title:"URR"},
	]
	data = []
	getData(){
		this.loading = true
		setTimeout(()=>{
			this.loading = false
		},500)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/bloodFlow/index.vue